module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAARCAYAAADkIz3lAAAApklEQVQoU43SLY4CQRAG0FeCBANiPQgcSNSaTcDAeZEIAoYEDoDaBMERdg/QZMgw4acbKP1SXfVVh0KllLpY4AvjyLkaLfGNXwyf4AM6YhoRpztYQtWrDXyFGvgOXeAn6ArXmKAZPJdE1fGAEfaYRcRfCfawwQA7zHP4snVK6S2+jeclfgy8iHMn7KNK4m7m0qe4xVv8ZGG9YIVX6KBXhDVuoxUR/2fxyl4SLzGYCQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/head-back.png
// module id = 1vDo
// module chunks = 0